import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { global } from '../../models/global';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { SessionService } from '../../Services/session.service';
import { EncryptionDecryptionService } from 'src/app/Services/encryption-decryption/encryption-decryption.service';
import { DashboardService } from 'src/app/Services/Dashboard/dashboard.service';
import { Notify, UpdateNotification } from 'src/app/Models/login/profile';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector : 'app-layout',
  templateUrl : './HomeLayout.Component.html'

})
export class HomeLayoutComponent implements OnInit {
  userName;
  RoleId : string;
  IsShow : boolean;
  loader : string = 'none';
  ROOT_URL : string = "";
  loadAPI : Promise<any>;
  searchValue : string = '';
  menuList : any[] = [];
  notify : Notify=new Notify();
  count : number = 0;
  constructor(private session : SessionService, private router : Router, private route : ActivatedRoute,
    private snackBar : MatSnackBarComponent, private encryptionDecryptionService : EncryptionDecryptionService,
    private dashboardService : DashboardService, private loginService : LoginService,private toastr: ToastrService) {
    this.loadAPI = new Promise((resolve) => {
      this.getMenuList();
      resolve(true);
    });
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
    this.notification();
    //set username to show on the Dashboard and other pages
    this.userName = localStorage.getItem('mcmt_userName');
    this.RoleId = localStorage.getItem('mcmt_roleID');
  }

  ngOnInit() {
    this.loadScript();
  }

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
        isFound = true;
      }
    }
    if (!isFound) {
      var dynamicScripts = ["assets/js/script.js"];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }

    }

  }



  //Redirect to C-Master Change password page on Click over Change Password link
  changePassword() {
    var userid = localStorage.getItem('mcmt_userId');
    var encodedUserid = btoa(userid);
    var encodePortal = btoa('MCMT');
    if (this.ROOT_URL.indexOf('mcmaterial.uat.fmcone.in') !== -1)
      var url = 'https://cmaster.uat.fmcone.in/ChangePassword?user=' + encodedUserid + '&portal=' + encodePortal;
    else
      var url = 'https://cmaster.fmcone.in/ChangePassword?user=' + encodedUserid + '&portal=' + encodePortal;
    window.open(url, "_blank");
  }

  logout() {
    this.session.logout();
  }

  notification(){
    this.loginService.notification()
      .subscribe((resData : any) => {
        if (resData.status == true) {
          this.notify = resData.data;
          if(this.notify.unReadMsg[0].count > 0){
            this.count = this.notify.unReadMsg[0].count;
          }
          else{
            this.count = 0;
          }
        }
        else {
          this.toastr.error(resData.msg);
        }
      }
      );
  }

  getMenuList() {
    this.dashboardService.getMenuList()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          let response = resData.data;
          var menulist = response.filter(menu => menu.parentID == 0);
          var Innermenulist = response.filter(menu => menu.parentID > 0);
          var Menulist = [];
          menulist.forEach(function (parent) {
            var detail = {
              MenuName: parent.menuName,
              Class: parent.class,
              RouteValue: parent.route,
              State: parent.state,
              TemplateUrl: parent.templateUrl,
              Innermenulist: []
            };
            Innermenulist.forEach(function (child) {
              if (parent.menuID === child.parentID) {
                var subdetail = {
                  MenuName: child.menuName,
                  Class: child.class,
                  RouteValue: child.route,
                  State: child.state,
                  TemplateUrl: child.templateUrl
                };
                detail.Innermenulist.push(subdetail)

              }
            });
            Menulist.push(detail)
          });
          this.menuList = Menulist;
        } else {
          this.toastr.error(resData.message);
        }
      }
      );
  }

  delete(id : any, read : any, active : any) {
    let approvedQuantity : UpdateNotification[] = [];
    if(id == 0){
      this.notify.notification.forEach(function (detail){
        var approvedQty =
        {
          ID : detail.id,
          Read : true,
          Active : false
        };
        approvedQuantity.push(approvedQty);
      })
    }
    else{
      var approvedQty =
      {
        ID : id,
        Read : read,
        Active : active
      };
      approvedQuantity.push(approvedQty);  
    }
      this.dashboardService.updateNotification(approvedQuantity)
        .subscribe((resData: any) => {
          if (resData.status == true) {
            this.notification();
          }
        })
  }

  color(index : any){
    if(this.notify.notification[index].isRead == false)
    {
      return 'cornsilk'
    }
    else
    {
      return 'white'
    }
  }
}
